import LiveKitPrimaryButton from '../../components/LiveKitPrimaryButton';
import { formatUserName } from '../../utils/utils';

import { Card, DateUtils, Flex, Icon } from '@amigoapp/doca-react';
import classNames from 'classnames';

const STARS = [1, 2, 3, 4, 5];

const LiveKitTelemedicineFinished = ({
	date,
	feedbackText,
	rating,
	submitted,
	user,
	onCloseSubmitted,
	onFeedbackTextChange,
	onSelectRating,
	onSubmitFeedback
}) => (
	<Flex align="center" className="lk-finished" direction="col" flex={1} gap={4} justify="between">
		<div className="lk-finished__center">
			<Card className="lk-surface-card lk-finished__card">
				<div className="lk-finished__check">
					<Icon name="check" type="solid" />
				</div>

				<h2 className="lk-finished__title">Teleconsulta finalizada</h2>
				<p className="lk-finished__meta">
					{DateUtils.format(date, { format: 'ddd, DD [de] MMMM [-] HH:mm[h]' })} · {formatUserName(user.title, user.name)}
				</p>

				<div className="lk-finished__rule" />

				<p className="lk-finished__question">Como foi sua consulta?</p>
				<p className="lk-finished__hint">O áudio e o vídeo estavam bons?</p>

				<div className="lk-rating">
					{STARS.map(star => (
						<button
							key={star}
							aria-label={`${star} de 5`}
							className="lk-rating__btn"
							type="button"
							onClick={() => onSelectRating(star)}
						>
							<Icon
								className={classNames('lk-rating-star', { 'lk-rating-star--active': star <= rating })}
								name="star"
								type={star <= rating ? 'solid' : 'light'}
							/>
						</button>
					))}
				</div>

				{rating > 0 && rating < 5 && (
					<textarea
						className="lk-feedback-textarea"
						placeholder="O que podemos melhorar? (opcional)"
						rows={3}
						value={feedbackText}
						onChange={onFeedbackTextChange}
					/>
				)}

				{rating > 0 && (
					<LiveKitPrimaryButton onClick={onSubmitFeedback}>
						Enviar feedback
					</LiveKitPrimaryButton>
				)}
			</Card>
		</div>

		{submitted && (
			<div className="lk-modal-overlay">
				<div className="lk-modal lk-modal--narrow">
					<div className="lk-finished__check lk-finished__check--primary">
						<Icon name="check" type="solid" />
					</div>
					<h3 className="lk-finished__title">Obrigado pelo seu feedback!</h3>
					<p className="lk-finished__meta">
						Sua opinião nos ajuda a melhorar a experiência de teleconsulta.
					</p>
					<LiveKitPrimaryButton onClick={onCloseSubmitted}>Fechar</LiveKitPrimaryButton>
				</div>
			</div>
		)}

		<img alt="Amigo - Logo" className="lk-brand-logo doca-mb-8" src="https://cdn.amigotech.com.br/logos/amigo.svg" />
	</Flex>
);

export default LiveKitTelemedicineFinished;
